import React, { FunctionComponent } from 'react'

import { IProps, IPropsCss } from './IProps'
import {
    PageTitle,
    SectionTitle,
    SubSectionSectionTitle,
    SubSectionTitle,
} from './style'

export const Heading: FunctionComponent<IProps> = ({
    level,
    color,
    textAlign,
    css,
    ...props
}) => {
    const components = {
        pageTitle: PageTitle,
        sectionTitle: SectionTitle,
        subSectionTitle: SubSectionTitle,
        subSectionSectionTitle: SubSectionSectionTitle,
    }
    const HeaderComponent: FunctionComponent<IPropsCss> = components[level]

    return (
        <HeaderComponent color={color} textAlign={textAlign} css={css}>
            {props.children}
        </HeaderComponent>
    )
}
